module.exports = __webpack_public_path__ + "img/03-01-img-01@2x.cb136dfa.png";